import React, { useContext, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import Editor from "@monaco-editor/react";
import "react-quill/dist/quill.snow.css";
import { AppContext } from "../context/AppContext";
import ReactQuill from "react-quill-new";
import { useNavigate } from "react-router-dom";

function CreateContent() {
  const navigate = useNavigate();
  const {
    contentLoading,
    createContent,
    fetchAllContentsData,
    fetchAllContentsDataNew,
  } = useContext(AppContext);
  const [contentData, setContentData] = useState({
    page_slug: "",
    section_name: "",
    content_key: "",
    position: 0,
    content_value: "",
  });
  const [errors, setErrors] = useState({});
  const [isRichText, setIsRichText] = useState(true);
  const [code, setCode] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;
    if (name === "position") {
      sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    setContentData((prev) => ({ ...prev, [name]: sanitizedValue }));
  };
  const validateForm = () => {
    const validationErrors = {};
    let isValid = true;

    // Check each field for emptiness
    if (!contentData.slug) {
      validationErrors.slug = "Slug is required";
      isValid = false;
    }

    if (!contentData.section_name) {
      validationErrors.section_name = "Section name is required";
      isValid = false;
    }

    if (!contentData.content_key) {
      validationErrors.content_key = "Content key is required";
      isValid = false;
    }

    if (contentData.position <= 0) {
      validationErrors.position = "Position cannot be 0 or less";
      isValid = false;
    }

    if (!contentData.content_value) {
      validationErrors.content_value = "Content value is required";
      isValid = false;
    }

    setErrors(validationErrors);
    return isValid;
  };

  const handleEditorChange = (value) => {
    setContentData((prev) => ({ ...prev, content_value: value }));
    setCode(value);
  };

  const handleToggle = async () => {
    setIsRichText(!isRichText);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (isValid) return;

    await createContent(contentData, {
      onSuccess: async (res) => {
          toast.success("New Content created successfully!");
          navigate("/contents");
        await fetchAllContentsData();
        await fetchAllContentsDataNew();
      },
      onFailed: (err) => {
        const msg = err.errormessage ?? "Content is not created!"
        toast.error(msg);
        console.log("Creating content error", err);
      },
    });
  };

  console.log(errors);

  return (
    <MasterLayout>
      <div class="content-form-container">
        <div class="content-form-wrapper">
          <div class="content-form-header">
            <h1 class="content-form-title fs-5">Content Creation Form</h1>
          </div>

          <form class="content-management-form" onSubmit={handleSubmit}>
            <div class="content-form-field-group">
              <label for="sectionName" class="content-form-label">
                Slug <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="sectionName"
                name="page_slug"
                class="content-form-input"
                placeholder="Enter section name"
                value={contentData.page_slug}
                onChange={handleChange}
                required
              />
              {contentData.page_slug.length == 0 && errors.slug && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.slug}
                </span>
              )}
            </div>
            <div class="content-form-field-group">
              <label for="sectionName" class="content-form-label">
                Section Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="sectionName"
                name="section_name"
                class="content-form-input"
                placeholder="Enter section name"
                value={contentData.section_name}
                onChange={handleChange}
                required
              />
              {contentData.section_name.length == 0 && errors.section_name && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.section_name}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="contentKey" class="content-form-label">
                Content Key <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="contentKey"
                name="content_key"
                class="content-form-input"
                placeholder="Enter content key"
                value={contentData.content_key}
                onChange={handleChange}
                required
              />
              {contentData.content_key.length == 0 && errors.content_key && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.content_key}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="position" class="content-form-label">
                Position <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                id="position"
                name="position"
                class="content-form-input"
                placeholder="Enter position number"
                value={contentData.position}
                onChange={handleChange}
              />
              {contentData.position == 0 && errors.position && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.position}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="content" class="content-form-label">
                Content <span className="text-danger">*</span>
              </label>
              <button
                type="button"
                onClick={handleToggle}
                className="toggle-editor-btn"
              >
                {isRichText ? "Edit with HTML tags" : "Switch to Rich Text"}
              </button>
              <span className="info__">
                * If you are using more internal tags for styling, we recommend
                the HTML Editor over the text editor.
              </span>
              <div className="content-rich-editor-wrapper">
                {isRichText ? (
                  <ReactQuill
                    theme="snow"
                    value={contentData.content_value}
                    onChange={(e) =>
                      setContentData((prev) => ({ ...prev, content_value: e }))
                    }
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, false] }],
                        [{ color: [] }, { background: [] }],
                        ["blockquote", "code-block"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ align: [] }],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "code-block",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                      "image",
                      "color",
                      "background",
                      "align",
                      "clean",
                    ]}
                  />
                ) : (
                  <Editor
                    height="300px"
                    defaultLanguage="html"
                    language="html"
                    theme="vs-dark"
                    value={code}
                    onChange={handleEditorChange}
                    options={{
                      fontSize: 14,
                      minimap: { enabled: false },
                      automaticLayout: true,
                      wordWrap: "on",
                      formatOnPaste: false,
                      formatOnType: false,
                      renderWhitespace: "all", // Ensures all spaces are preserved
                      tabSize: 2, // Makes sure indentation is correct
                    }}
                  />
                )}

                {contentData.content_value.length == 0 &&
                  errors.content_value && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.content_value}
                    </span>
                  )}
              </div>
            </div>

            <button
              type="submit"
              class="content-form-submit"
              disabled={contentLoading}
            >
              {!contentLoading ? (
                " Submit"
              ) : (
                <PulseLoader color="#fff" size={10} />
              )}
            </button>
          </form>
        </div>
      </div>
    </MasterLayout>
  );
}

export default CreateContent;
